export default __webpack_public_path__ + "static/media/2410.3af640c1.png";